import { gql } from '@apollo/client'
import {
  EvaluateBatch,
  EvaluateBatchVariables,
  EvaluateBatch_evaluateBatch
} from 'src/smart/mutations/types/EvaluateBatch'
import { SmartMutation } from 'src/smart/SmartMutation'

export const SM_EVALUATE_BATCH: SmartMutation<
  EvaluateBatchVariables,
  EvaluateBatch,
  EvaluateBatch_evaluateBatch
> = {
  mutation: gql`
    mutation EvaluateBatch($batchId: String!) {
      evaluateBatch(batchId: $batchId) {
        batchId
        status
      }
    }
  `,
  extract: ({ evaluateBatch }) => evaluateBatch
}
